import { UpcomingApplicationCardOverview } from "@/components/molecules/application/upcoming-application.card.overview";
import { AgendaStatusBadge } from "@/components/molecules/shift/agenda-status-badge";
import { UpcomingShiftCardRework } from "@/components/molecules/shift/upcoming-shift-card.rework";
import { type AgendaItem } from "@/lib/hooks/use-upcoming-agenda";

/**
 * One row in the "Aankomend" list: the status, then the card that belongs to it. Keeping the badge
 * here rather than inside each card component means every list gets exactly the same treatment, and
 * a card stays reusable outside a status context (the Vandaag hero, for one, states its status as a
 * countdown instead).
 */
export function AgendaListItem({ item }: { item: AgendaItem }) {
  return (
    <div className="flex flex-col gap-3">
      <AgendaStatusBadge status={item.status} />
      {item.status === "confirmed" && <UpcomingShiftCardRework shift={item.shift} />}
      {item.status === "applied" && (
        <UpcomingApplicationCardOverview application={item.application} />
      )}
    </div>
  );
}
